import { assertNever } from '@lessonup/utils';
import { GeneratedResultProps } from '../../../../../components/GeneratedResult/GeneratedResult';

export type GeneratedResultItem = Omit<GeneratedResultProps, 'selected'>;

export function generatedResultIsEmpty(result: GeneratedResultItem): boolean {
  const { content } = result;
  switch (content.type) {
    case 'openQuestion':
      return !content.question;
    case 'slide':
      return !content.header && !content.text;
    case 'poll':
      return !content.question && !content.answers.length;
    case 'quiz':
      return !content.question && !content.answers.length;
    case 'wordweb':
      return !content.word;
    default:
      assertNever(content, 'Unknown content type ');
  }
}
